import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import DOMComponent from '../components/dom.component';
import { domSettings } from '../../../../../redux/dom-settings/action';
import { selectDomSettingsQueryItems } from '../../../../../redux/dom-settings/selector';

const ManagementDOMSettings = () => {
  const dispatch = useAppDispatch()
  const domSettingsQuery = useSelector(selectDomSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectDOMSettings, setSelectDOMSettings] = useState<any>([])

  const fetchDOMSettingsQueryById = () => {
    dispatch(domSettings.query({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom/query`,
      entity: 'domSettings',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectDOMSettings({ ...selectDOMSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchDOMSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectDOMSettings(domSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(domSettings.resetAction({ actionType: 'update' }))
    await dispatch(domSettings.update({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/dom`,
      entity: 'domSettings',
      jsonData: {
        Records: [
          selectDOMSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <DOMComponent
          handleInnerFormChange={handleInnerFormChange}
          selectDOMSettings={selectDOMSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementDOMSettings;